import dayjs from 'dayjs';

export function disablePastdate(current: dayjs.Dayjs, timezoneDate: string) {
  return current && current < dayjs(timezoneDate).startOf('day');
}
export function disablePastTime(referenceTime: string | dayjs.Dayjs, selectedDate?: string | dayjs.Dayjs) {
  const now = dayjs(referenceTime);
  const resolvedDate = selectedDate ? dayjs(selectedDate) : null;

  return function () {
    if (!resolvedDate) return {};

    const isPastDay = resolvedDate.isBefore(now, 'day');
    const isSameDay = resolvedDate.isSame(now, 'day');

    if (isPastDay) {
      return {
        disabledHours: () => Array.from({ length: 24 }, (_, i) => i),
        disabledMinutes: () => Array.from({ length: 60 }, (_, i) => i),
        disabledSeconds: () => Array.from({ length: 60 }, (_, i) => i),
      };
    }

    if (!isSameDay) {
      return {
        disabledHours: () => [],
        disabledMinutes: () => [],
        disabledSeconds: () => [],
      };
    }

    return {
      disabledHours: () => Array.from({ length: now.hour() }, (_, i) => i),

      disabledMinutes: (hour: number) => (hour === now.hour() ? Array.from({ length: now.minute() }, (_, i) => i) : []),

      disabledSeconds: (hour: number, minute: number) =>
        hour === now.hour() && minute === now.minute() ? Array.from({ length: now.second() }, (_, i) => i) : [],
    };
  };
}
